import { SharedState } from '@trello/shared-state';

import type { FeatureNames } from './featuresInfo';

interface FeedbackCollectorSharedState {
  featureName?: FeatureNames;
  traceId?: string;
  flagTreatment?: boolean;
  isOpen: boolean;
}

const defaultFeedbackCollectorSharedState: FeedbackCollectorSharedState = {
  isOpen: false,
};

export const feedbackCollectorSharedState =
  new SharedState<FeedbackCollectorSharedState>(
    defaultFeedbackCollectorSharedState,
  );
